export default {
      id: "header_bg-usage",
      viewBox: "0 0 845 134",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#header_bg-usage",
      toString: function () {
        return this.url;
      }
    }